import { render, staticRenderFns } from "./TabalSimsSelected.vue?vue&type=template&id=5f351f08&"
import script from "./TabalSimsSelected.vue?vue&type=script&lang=ts&"
export * from "./TabalSimsSelected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5f351f08', component.options)
    } else {
      api.reload('5f351f08', component.options)
    }
    module.hot.accept("./TabalSimsSelected.vue?vue&type=template&id=5f351f08&", function () {
      api.rerender('5f351f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/VerificacionBajaCliente/Editar/TabalSimsSelected.vue"
export default component.exports